import React from "react"

import { connect } from "scrivito"

import { GlobalSearchOverlay } from "./GlobalSearchOverlay"
import { useGlobalSearchOverlayModel } from "./model/useGlobalSearchOverlayModel"

function GlobalSearchOverlayConnectorComponent() {
  return <GlobalSearchOverlay {...useGlobalSearchOverlayModel()} />
}

export const GlobalSearchOverlayConnector = React.memo(
  connect(GlobalSearchOverlayConnectorComponent)
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    GLOBAL_SEARCH_OVERLAY: null
  }
}
